import { render, staticRenderFns } from "./salesmanTrainingStatistics.vue?vue&type=template&id=5852c8e8&scoped=true"
import script from "./salesmanTrainingStatistics.vue?vue&type=script&lang=js"
export * from "./salesmanTrainingStatistics.vue?vue&type=script&lang=js"
import style0 from "./salesmanTrainingStatistics.vue?vue&type=style&index=0&id=5852c8e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5852c8e8",
  null
  
)

export default component.exports